<template>
    <div id="formContainer" ref="formContainer" class="container-big mx-auto prelative">
        <preloader :display="loading" class="preloader prelative" />

        <!-- FORM NAV (save & quit) -->
        <div class="pfixed white-bkg third-form-nav py-3 px-5 flex-level flex-end span_12 zi-2">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                :data-bot="getDatabot('cancel', current, 'bottom', 'btn')"
                @click="goBack()"
            />
            <CompassButton
                :label="labelSaveAndAction"
                type="secondary"
                :data-bot="getDatabot(databotKey, current, 'bottom', 'btn')"
                class="ml-2"
                @click.prevent="saveAndAction(current, 'reset')"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                class="ml-2"
                :data-bot="getDatabot('save', current, 'bottom', 'btn')"
                @click.prevent="saveAndAction(current, 'redirection')"
            />
        </div>

        <h1 class="my-0"><slot name="title"></slot></h1>
        <a v-if="canBack" class="link mr-2 flex-level ln-20 mt-1" @click="goBack()">
            <i class="icon-arrow-back mr-1"></i>
            <span>{{ goBackTxt }}</span>
        </a>

        <el-form
            :ref="current"
            :model="getModel"
            :rules="getRules"
            label-position="top"
            class="flex-row jc-space"
        >
            <!-- MAIN -->
            <div class="third-form">
                <slot></slot>
            </div>

            <!-- SIDE PANEL -->
            <form-side-params ref="thirdFormParams" :entity="current"></form-side-params>
        </el-form>
    </div>
</template>

<script>
import FormSideParams from 'vcomponents/forms/FormSideParams.vue';
import FormMixins from 'mixins/FormMixins';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        FormSideParams,
        Preloader,
    },
    mixins: [FormMixins, DataBotsFormsMixins],
    props: {
        linkedForm: {
            type: Object,
            required: false,
        },
        store: {
            type: Object,
            required: true,
        },
        current: {
            type: String,
            required: true,
        },
        redirection: {
            type: String,
            required: false,
        },
        labelSaveAndAction: {
            type: String,
            required: true,
        },
        deletionConfirmation: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            action: null,
            loading: true,
            toOverview: false,
        };
    },
    computed: {
        //if coming back here from back/history && has pending form data saved in sessionstorage
        isComingFromChildrenForm() {
            return (
                window.history &&
                window.history.pushState &&
                sessionStorage.getItem('to_contact_form_session_storage')
            );
        },
        getModel() {
            return this.$store.getters[`${this.current}/getModel`];
        },
        getState() {
            return this.$store.getters[`${this.current}/getState`];
        },
        getRules() {
            return this.$store.getters[`${this.current}/getRules`];
        },
        getCustomFields() {
            return this.$store.getters[`${this.current}/customFields`];
        },
        getId() {
            return this.$store.getters[`${this.current}/getId`];
        },
        canBack() {
            return this.linkedForm && !!this.linkedForm.back ? true : false;
        },
        goBackTxt() {
            if (this.linkedForm && !!this.linkedForm.back) {
                return this.linkedForm.backMsg;
            }
        },
        smartTagsAllowed() {
            return this.$store.getters[`${this.current}/getParamsConfig`];
        },
        databotKey() {
            let type = this.current.slice(0, this.current.indexOf('Form'));
            return `save-and-create-another-${type}`;
        },
    },
    created() {
        //set smartTags if store was already created and is the highest form parent
        if (
            this.linkedForm?.state?.paramsSettings &&
            !this.linkedForm.back &&
            this.smartTagsAllowed?.smarttags
        ) {
            this.$store.dispatch(
                `${this.current}/updateSmartTags`,
                this.linkedForm.state.paramsSettings.smartTags,
            );
        }
    },
    mounted() {
        //fetchMetadata
        this.fetchMetadata()
            .then(() => {
                let pendingStore = null;

                if (this.linkedForm && this.linkedForm.state) {
                    pendingStore = this.linkedForm;
                } else if (this.isComingFromChildrenForm) {
                    pendingStore = JSON.parse(
                        sessionStorage.getItem('to_contact_form_session_storage'),
                    )?.linkedForm;
                }

                if (!_.isNil(pendingStore))
                    this.$store.dispatch(`${this.current}/fetchPendingStore`, pendingStore);
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                Push.error(
                    this.$l10n.__(
                        'Une erreur est survenue lors de la récupération des données. Veuillez ré-essayer ultérieurement.',
                    ),
                );
            });
        document.getElementById('sellsy_app').classList.add('white-bkg');
    },
    beforeMount() {
        window.addEventListener('beforeunload', (event) => {
            //destroy pending form data in sessionStorage at reload
            if (sessionStorage.getItem('to_contact_form_session_storage')) {
                sessionStorage.removeItem('to_contact_form_session_storage');
            }
        });
    },

    beforeDestroy() {
        document.getElementById('sellsy_app').classList.remove('white-bkg');
    },
    methods: {
        ...popupPanelMapActions(['open']),

        fetchMetadata() {
            return this.$store.dispatch(`${this.current}/fetchMetadata`);
        },

        clearThird() {
            return this.$store.dispatch(`${this.current}/clearThird`);
        },

        updateThird() {
            return this.$store.dispatch(`${this.current}/updateThird`, this.action);
        },

        goBack() {
            if (this.linkedForm && this.linkedForm.back) {
                this.goBackLinkedForm(false);
            } else if (this.deletionConfirmation) {
                this.openWarningPopUp();
            } else {
                history.back();
            }
        },
        openWarningPopUp() {
            this.open({
                key: `popupWarningThirdForm`,
                props: {
                    currentStore: this.current,
                    contextType: 'cancelForm',
                },
            });
        },
        goBackLinkedForm(saved) {
            let newDatas = saved ? { datas: this.getState, label: this.current } : null;
            if (!_.isNil(newDatas)) {
                newDatas.datas.contact.customFields =
                    this.getCustomFields && this.getCustomFields.length > 0
                        ? this.getCustomFields
                        : [];
            }
            let format = {
                linkedForm: {
                    name: this.current,
                    state: this.linkedForm.state,
                    newDatas: newDatas,
                    back: false,
                    new: this.linkedForm.new,
                    index: this.linkedForm.index,
                },
            };
            let routeIndex = this.linkedForm.name.indexOf('Form');
            let route = this.linkedForm.name.substr(0, routeIndex);
            this.$router.push({ name: `${route}.form`, params: format });
        },

        /**
         * Call to save datas
         */
        save() {
            // If current form was pushed from a parent form.
            if (this.linkedForm && this.linkedForm.back) {
                this.goBackLinkedForm(true);
            } else {
                //If current form is single
                this.updateThird()
                    .then((response) => {
                        this.$refs.thirdFormParams.resetNote();
                        //if redirection:
                        if (this.toOverview && response) {
                            this.$router.push({ name: this.redirection, params: response });
                        } else if (this.isComingFromChildrenForm) {
                            sessionStorage.removeItem('to_contact_form_session_storage');
                        } else {
                            this.scrollToTop();
                        }
                    })
                    .catch((errors) => {
                        if (errors?.response?.error?.details) {
                            this.errors.setErrors(errors.response.error.details);
                            this.$emit('catch-errors', this.errors);
                        }
                        Push.error(
                            this.$l10n.__("Une erreur est survenue lors de l'enregistrement"),
                        );
                    });
            }
            this.action = '';
        },

        saveAndAction(form, action) {
            if (action === 'redirection') this.toOverview = true;
            if (action === 'reset') this.action = 'reset';
            this.submitForm(form, null, false, true);
        },
    },
};
</script>

<style lang="scss">
.third-form {
    padding-bottom: 0px !important;
    & > div:last-child {
        padding-bottom: 170px !important;
    }

    //fix bcause of the white background issue with SPA
    .el-collapse-item .el-collapse-item__header,
    .el-collapse-item .el-collapse-item__wrap {
        background: unset !important;
    }
    .el-form-item__error {
        position: relative;
    }
}
</style>
